import { DragDropListsEvents, ItemProps } from '../../dtos'

export interface OnItemClick {
    onItemClickServer?: DragDropListsEvents['onItemClick']
}

export const itemClick = ({ onItemClickServer }: OnItemClick) => {
    const onItemClick = (id: string) => {
        if (onItemClickServer) {
            onItemClickServer(id)
        } else {
            console.log('Please provide a "onItemClick" props')
        }
    }

    return onItemClick
}
